import $ from "jquery"
import { trace } from "./../shared/helpers.js"
import InfinityScroll from "./../shared/InfinityScroll";
import LoaderAnimation from "./../shared/LoaderAnimation.js"
import UMasonry from "./../shared/UMasonry";

const Catalogue = {
  isLoading: false,
  infinityscroll: false,
  time: false,
  url: false,
  childSelector: false,
  limit: 0,
  start: 0,
  $container: false,  


  // stream loaded
  onStreamLoaded(numberLoaded) {
    LoaderAnimation.hide();
    $('[data-spy=affix]').each(function () { 
      $(this).affix('checkPosition'); 
    });

    // stream ends?
    trace("loaded", numberLoaded, " end?", numberLoaded < this.limit);
    if (numberLoaded < this.limit) {
      if (this.infinityscroll) {
        InfinityScroll.streamEnd = true;
        InfinityScroll.removeDocumentEvents();
      }
    } else {
      // move start position
      this.start += this.limit
    }
    this.isLoading = false;
  },
  // load - get request
  loadStream() {
    if (this.isLoading) {
      return false;
    }
    this.isLoading = true;
    document.documentElement.classList.add("infinity-scroll-loading")
    trace("load stream, start", this.start, "limit", this.limit);
    LoaderAnimation.show();
    let $container = this.$container;
    // params
    let params = {};
    params.limit = this.limit;
    params.start = this.start;
    if (this.time) {
      params.ut = this.time;
    }
    trace ("Ajax GET params: ", params);    
    $.get(this.url, params, (result)=> {
      let $result = $(result);      
      // number of loaded items
      const elements = $('<div></div>').append($result).find(this.childSelector);
      $container.append($result);
      Catalogue.onStreamLoaded(elements.length);
      if (this.$container.hasClass('masonry-loader')) {
        UMasonry.appended($container)
      }
    }).done(function() {
    }).fail(function() {
    }).always(function() {
      document.documentElement.classList.remove("infinity-scroll-loading")
    });
  },
  // ############
  // ### init ###
  // ############
  init() {    
    this.$container = $('.catalogue-main .list-wrapper[data-infinity-scroll="true"]');
    if (this.$container.length < 1) {
      return false;
    }

    this.infinityscroll = true;    
    if (this.$container.data("filter-year") == true) {
      this.time = this.$container.data("time");
      trace( "time", this.time);
    }
    this.url = this.$container.data("url");
    this.childSelector = this.$container.data("child-selector");
    this.limit = this.$container.data("limit");    
    this.start = this.$container.data("start");    
    // initial load ?
    // this.loadStream();

    // infinity scroll?
    if (this.infinityscroll) {
      InfinityScroll.init(this.$container, this.loadStream.bind(this));
    }

  },

}

export default Catalogue;